import { OAuthPopup } from "@tasoskakour/react-use-oauth2";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import { AuthorizePageMock } from "./auth/authorize-page-mock";
import { useAuth } from "./auth/useAuth";
import { MachineSelectorDialog } from "./containers/machine-selector/machine-selector-dialog";
import { createI18n } from "./i18n";
import { QueryClient } from "./providers/query-client/query-client";
import { NoteDialog } from "./containers/note/note-dialog";
import { enableMockServer, mockAuthUrl } from "./lib/utils";
import { Home } from "./containers/home/home";
import { CompleteOperationDialog } from "./containers/complete-operation/complete-operation-dialog";
import { RoutingSheet } from "./containers/routing/routing-sheet";
import { DocumentSheet } from "./containers/documents/document-sheet";
import { ROUTES } from "./routes";
import { Toaster } from "./components/ui/toaster/sonner";
import { CreateNCDialog } from "./containers/create-nc/create-nc-dialog";
import { OpCenterDialog } from "./containers/opcenter/opcenter-dialog";
import { SentenceNCDialog } from "./containers/sentence-nc/sentence-nc-dialog";
import { routerMode, routerBase } from "../config.json";
import { AuthGuard, OperationGuard } from "./containers/home/route-guards";

const Router = routerMode === "hash" ? HashRouter : BrowserRouter;

export const App = () => {
  const { user } = useAuth();
  const i18n = createI18n(user?.language);

  return (
    <I18nextProvider i18n={i18n}>
      <QueryClient>
        <Router basename={routerMode === "hash" ? undefined : routerBase}>
          <Routes>
            <Route element={<AuthGuard />} path={ROUTES.HOME}>
              <Route element={<Home />} path={ROUTES.HOME}>
                <Route
                  path={ROUTES.SELECT_MACHINE}
                  element={<MachineSelectorDialog />}
                />
                <Route
                  element={<OpCenterDialog />}
                  path={ROUTES.OPCENTER(":resource")}
                />
                <Route path={ROUTES.HOME} element={<OperationGuard />}>
                  <Route
                    path={ROUTES.COMPLETE_OPERATION}
                    element={<CompleteOperationDialog />}
                  />
                  <Route path={ROUTES.SAP_NOTE} element={<NoteDialog />} />
                  <Route path={ROUTES.ROUTING} element={<RoutingSheet />} />
                  <Route
                    path={ROUTES.DOCUMENTS(":docId?")}
                    element={<DocumentSheet />}
                  />
                  <Route
                    element={<CreateNCDialog />}
                    path={ROUTES.DECLARE_DEVIATION}
                  />
                  <Route
                    element={<SentenceNCDialog />}
                    path={ROUTES.SENTENCE_NC(":ncNId")}
                  />
                </Route>
              </Route>
            </Route>
            <Route
              element={<OAuthPopup />}
              path={routerMode === "hash" ? "*" : "/callback"}
            />
            {enableMockServer() && (
              <Route element={<AuthorizePageMock />} path={mockAuthUrl} />
            )}
          </Routes>
          <Toaster />
        </Router>
      </QueryClient>
    </I18nextProvider>
  );
};
